<template>
	<div class="p_box" id="box">
		<el-breadcrumb separator="/" id="head">
			<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/Select' }" replace>制作习题</el-breadcrumb-item>
			<el-breadcrumb-item>制作答题卡</el-breadcrumb-item>
		</el-breadcrumb>
		<div :style="{ height: height + 'px' }" class="content_box overflow p_m_t_30 p_flex">
			<div class="p_f_3">
				<div>
					<div class="p_flex p_logins p_f_a p_m_t_30">
						<span class="p_m_l_30 type_size_18 ">试卷名称</span>
						<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="name" placeholder="请输入试卷名称"></el-input></div>
					</div>
				</div>
				<div >
					<div class="uploading" v-if="show">
						<el-upload
							class="upload-demo"
							:action="hast"
							:headers="$request.headers(true)"
							:show-file-list="false"
							multiple
							:on-success="uploadImage"
							accept=".png, .jpg,.pdf,.doc,.docx"
							:limit="99"
							:before-upload="handleBeforeUpload"
						>
							<div class="shang_chuan p_m_t_50">
								<div class="p_flex p_f_c p_f_a">
									<div class="chuan_img"><img src="../../../assets/img/shangchuan.png" /></div>
									<span class="p_m_l_20 subject_color type_size_20">上传文件</span>
								</div>
								<span class="p_flex p_f_c type_size_16 p_m_t_30" style="color: #999999;">支持DOC,DOCX,PDF,PNG,JPG格式上传</span>
							</div>
						</el-upload>
					</div>
				</div>
				<div id="" v-if="img" style="height: 86%;"  class=" overflow">
					<div class="imgs" ><el-image style="width: 100%; height:auto;margin-top: 30px;" v-for="(item,index) in srcList" :key='index' :src="item" :preview-src-list="srcList"></el-image></div>
				</div>
				<div class="" v-if="iframe" style="height: 86%;">
					<iframe :src="url" style="width: 100%;height: 100%;"></iframe>
				</div>
			</div>
			<div class="p_f_2 p_m_l_30"><bian-ji :name="name" :url="urls" :srcList='srcList' :file_type='file_type' ></bian-ji></div>
		</div>
	</div>
</template>

<script>
import pdf from 'vue-pdf';
import BianJi from './components/bian_ji.vue';
export default {
	components: {
		BianJi,
		pdf
	},
	data() {
		return {
			height: 0,
			name: '',
			show: true,
			srcList: [],
			src: '',
			hast:'',
			url:'',
			img:false,
			iframe:false,
			file_type:'',
			urls:''
			// http://homework.zeonyu.com/static/upload/pdf/20211221/91b6e9ce124a175602d52104487a8668.pdf
			//url:'https://view.officeapps.live.com/op/view.aspx?src=http://homework.zeonyu.com/static/upload/word/20211222/d84a779ca0bd03dd489f391fcedcc959.docx'
		};
	},
	created() {
		this.hast = this.$request.ajaxUrl + '/Upload/answerCard'
	},
	mounted() {
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/AnswerSheet') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		handleBeforeUpload(file) {
			const typeList = ['doc', 'docx', 'pdf', 'png', 'jpg'];
			this.beforeUpload(file,typeList,)
		},
		beforeUpload(file, arr = [], mssage) {
			const typeList = [...arr];
			const fileName = file.name;
			const extension = fileName.substring(fileName.lastIndexOf('.') );
			if( extension == '.png' || extension == '.jpg'  ){

			}
		},
		uploadImage(e) {
			console.log(e)
			this.show = false;
			if( e.data.extension_name == 'png' || e.data.extension_name == 'jpg' ){
				this.srcList.push(e.data.file)
				this.img = true
				this.file_type = 3
			}else if ( e.data.extension_name == 'pdf' ) {
				this.url = e.data.file
				this.iframe = true
				this.file_type = 1
				this.urls = e.data.file
			}else{
				this.url = 'https://view.officeapps.live.com/op/view.aspx?src=' + e.data.file
				this.urls = e.data.file
				this.iframe = true
				this.file_type = 2
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.content_box > div:nth-child(1) {
	background-color: #ffffff;
}
.p_f_3 {
	flex: 3;
}
.p_f_2 {
	flex: 2;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
.p_logins {
	height: 64px;
	background: #f5f5f5;
	opacity: 1;
	border-radius: 10px;
	margin: 30px;
}
.uploading {
	margin: 0 30px;
}

>>> .upload-demo {
	width: 100%;
	height: 170px;
	background: #f5f5f5;
}
>>> .el-upload-dragger {
	border: none;
	width: 100%;
	height: 170px;
	background: #f5f5f5;
}
>>> .el-upload {
	width: 100%;
	height: 170px;
}
.shang_chuan {
	height: 100%;
}
.chuan_img {
	width: 36px;
	height: 33px;
}
.chuan_img img {
	width: 100%;
	height: 100%;
}
.imgs {
	padding: 30px 0;
	margin: 0 30px;
}
.pdf-set {
	overflow: auto;
	max-width: 375px;
	max-height: 530px;
}
.annotationLayer {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/answer_sheet/index.vue